import styled from "styled-components";

export const AggregationToolFormLayout = styled.form`
    display: grid;
    grid-auto-flow: row;
    gap: 1rem;
    grid-template-columns: minmax(0, 500px);
`;
